export type TableOfContentsHeadingProps = {
  id: string;
  header: string;
};

export type TocLinkVariant = 'default' | 'linear-progress-variant';

export const TOC_LINK_VARIANTS = {
  DEFAULT: 'default',
  LINEAR_PROGRESS: 'linear-progress-variant',
} as const satisfies Record<string, TocLinkVariant>;
